export default __webpack_public_path__ + "static/media/trader.c50a75c4.png";